import { useCallback, useEffect, useRef } from 'react';

const EVENTS = ['click', 'keydown', 'mousemove', 'scroll', 'touchstart'];

export const useIdleTimeout = ({ timeoutMinutes, enabled, onTimeout }) => {
  const timeoutRef = useRef(null);

  const clearTimer = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }, []);

  const resetTimer = useCallback(() => {
    if (!enabled || !timeoutMinutes) {
      return;
    }
    clearTimer();
    timeoutRef.current = setTimeout(() => {
      onTimeout();
    }, timeoutMinutes * 60 * 1000);
  }, [clearTimer, enabled, onTimeout, timeoutMinutes]);

  useEffect(() => {
    if (!enabled || !timeoutMinutes) {
      clearTimer();
      return undefined;
    }

    resetTimer();
    EVENTS.forEach((eventName) => window.addEventListener(eventName, resetTimer));

    return () => {
      clearTimer();
      EVENTS.forEach((eventName) => window.removeEventListener(eventName, resetTimer));
    };
  }, [clearTimer, enabled, resetTimer, timeoutMinutes]);
};
